import React from 'react';
import { Grid, Box, Typography } from '@mui/material';
import { useMediaQuery } from '@mui/material';

const WeekGrid = ({
    dateRangeWithPrices,
    onDayClick,
    space,
    getPriceColor,
    maxWidth = '100%',
    variant = 'default'
}) => {
    const isSmallScreen = useMediaQuery('(max-width:1150px)');
    if (!dateRangeWithPrices || dateRangeWithPrices.length === 0) return null;
    // Adjusted sizes for better readability
    const headerPadding = variant === 'compact' ? '4px' : '6px';
    const pricePadding = variant === 'compact' ? '4px' : '6px';
    const dayFontSize = variant === 'compact' ? '0.7rem' : '0.8rem';
    const priceSize = variant === 'compact' ? '0.9rem' : '1.1rem';

    return (
        <Grid
            container
            sx={{
                maxWidth,
                mx: 'auto',
                borderRadius: '12px',
                overflow: 'hidden',
                borderColor: 'divider',
                backgroundColor: '#fafafa',
            }}
        >
            {dateRangeWithPrices.map((dayInfo, index) => (
                <Grid
                    item
                    xs={12 / dateRangeWithPrices.length}
                    key={index}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        borderRight: index < dateRangeWithPrices.length - 1 ? '1px solid' : 'none',
                        borderColor: 'divider',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        '&:hover': {
                            backgroundColor: 'action.hover',
                            '& .price': {
                                transform: 'scale(1.05)',
                            }
                        },
                        '&:last-child': {
                            borderRight: 'none',
                        }
                    }}
                    onClick={() => onDayClick(space, dayInfo.date)}
                >
                    {/* Header */}
                    <Box
                        sx={{
                            width: '100%',
                            backgroundColor: 'white.main',
                            color: 'white',
                            py: headerPadding,
                            textAlign: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: '2px'
                        }}
                    >
                        <Typography
                            variant="caption"
                            sx={{
                                fontSize: dayFontSize,
                                fontWeight: 600,
                                letterSpacing: '0.5px',
                                lineHeight: 1,
                                opacity: 0.95
                            }}
                        >
                            {dayInfo.dayOfWeek}
                        </Typography>
                    </Box>

                    {/* Price */}
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            py: pricePadding,
                            px: 1,
                            width: '100%',
                            backgroundColor: '#ffffff',
                            position: 'relative',
                            minHeight: '36px',
                        }}
                    >
                        {/* Original price (displayed if higher than current price) */}
                       {/*  {dayInfo.original_price && dayInfo.original_price > dayInfo.price && (
                            <Typography
                                variant="caption"
                                sx={{
                                    position: 'absolute',
                                    top: '2px',
                                    right: '6px',
                                    fontSize: isSmallScreen ? '0.65rem' : crossedPriceSize,
                                    color: 'text.alert',
                                    textDecoration: 'line-through',
                                    lineHeight: 1,
                                    zIndex: 1,
                                    opacity: 0.7,
                                }}
                            >
                                £{dayInfo.original_price.toFixed(2)}
                            </Typography>
                        )} */}
                        <Typography
                            className="price"
                            variant="body2"
                            sx={{
                                fontSize: isSmallScreen ? '0.9rem' : priceSize,
                                fontWeight: 700,
                                color: getPriceColor(dayInfo.price, dayInfo.original_price, dayInfo.minimum_price),
                                transition: 'transform 0.2s ease',
                                minWidth: '45px',
                                textAlign: 'center',
                                zIndex: 2,
                                position: 'relative',
                                letterSpacing: '0.3px'
                            }}
                        >
                            {typeof dayInfo.price === 'number' ? `£${dayInfo.price.toFixed(2)}` : dayInfo.price}
                        </Typography>
                    </Box>
                </Grid>
            ))}
        </Grid>
    );
};

export default WeekGrid;